import React,{useState} from 'react';
import {  Card, CardActions, CardMedia, Typography } from '@mui/material';
import questionnaire from '../../../assets/images/questionnaire.jpg';
import no_image from '../../../assets/images/no_image.jpg';
import UserQuestionnaire from '../Questionnaire/UserQuestionnaire';

function Questionnaire({task, handleCompleteTask=()=>{}}) {
    const [isQuestionnaireList, setIsQuestionnaireList] = useState(false);
    const handleQuestionnaire = (flag) => {
        setIsQuestionnaireList(flag)
    }

    const getThumnail = (type) => {
        switch(type){
            case 'questionnaire':
                return questionnaire 
            default: 
                return no_image
        }
      }

  return (
    <>
        {!isQuestionnaireList && <div style={{width:'290px'}}><Card onClick={()=>handleQuestionnaire(true)}  size='small' sx={{margin:1}}>           
            <CardMedia
                component="img"
                alt={task.type}
                image={getThumnail(task.type)}
            />
            <CardActions sx={{paddingBottom:0,  backgroundColor: '#015681', color:'white', justifyContent:'center'}}>
                <Typography>{task.type}</Typography>
            </CardActions>
        </Card></div>}
        {isQuestionnaireList && <UserQuestionnaire handleCompleteTask={handleCompleteTask} handleQuestionnaire={handleQuestionnaire} task={task}/>}
    </>
  )
}

export default Questionnaire